export class OrderedTaskEvaluate {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get task() {
        return this.parent;
    }
    get latestSelectedOptionIndicies() {
        return this.task.steps.map((step) => step.stepState.latestSelectedOption && step.stepState.latestSelectedOption.optionIndex);
    }
}
